/**
 * @generated SignedSource<<ae5d22dc6c185c6702726c622f121990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityNoteForm_enquiry$data = {
  readonly __typename: "Enquiry";
  readonly id: string;
  readonly " $fragmentType": "ActivityNoteForm_enquiry";
};
export type ActivityNoteForm_enquiry$key = {
  readonly " $data"?: ActivityNoteForm_enquiry$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityNoteForm_enquiry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityNoteForm_enquiry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Enquiry",
  "abstractKey": null
};

(node as any).hash = "ada4550b34a3ea2df58d98514853e30c";

export default node;
